module.exports = __webpack_public_path__ + "img/image5.c9e5fb0b.png";